import { Box, Button, FormControl, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../api";
import InfoModal from "../components/InfoModal";
import { AgreementCheckbox } from "./AgreementCheckbox";
import { useOrderParams } from "./useOrderParams";
import { OrderParamsForm } from "./OrderParamsForm";

interface BanktransferFormProps {
    onClose: () => void;
}

const BanktransferForm: React.FC<BanktransferFormProps> = ({ onClose }) => {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
    const [kind, setKind] = useState<'offer' | 'privacy'>('offer');
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const orderParams = useOrderParams({initialPeriod: 3});
    const { amount, discount, currency, camerasAnalytics, camerasSimple, camerasAnalyticsFact, camerasSimpleFact, periodMon, setPeriodMon } = orderParams;
    
    useEffect(() => {
        setPeriodMon(3);
    },[]);

    const handleOpen = (kind: 'offer' | 'privacy') => {
        setIsModalOpen(true);
        setKind(kind);
    }

    const handleAccept = () => {
        setIsAgreementAccepted(true);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsAgreementAccepted(false);
        setIsModalOpen(false);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage("");
        
        if (!isAgreementAccepted) {
            alert(t('OrderForm.PleaseAcceptAgreement'));
            return;
        }

        if (camerasAnalyticsFact > camerasAnalytics ) {
            alert('Кількість активних камер з аналітикою перевищує Кількість замовлених');
            return;
        }

        if (camerasSimpleFact > camerasSimple ) {
            alert('Кількість активних камер без аналітики перевищує Кількість замовлених');
            return;
        }

        const param = {
            periodMon, 
            camerasAnalytics, 
            camerasSimple, 
            currency,
            pay_type: 'bank'
        };

        const order = await api.postPreInvoice(param, );
        if (!order?.activate) {
            // setErrorMessage(t('OrderForm.OrderCreationError'));
            // setErrorMessage('Order Creation Error');
            alert('Помилка створення замовлення');
            return;
        }
        const blob = await api.printOrder(order?.order_id || 0);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `order_${order}.pdf`;
        link.click();
        if (link.parentNode) {
            link.parentNode?.removeChild(link);
        }
        window.URL.revokeObjectURL(url);
    };

    return (
        <Paper elevation={3} sx={{ maxWidth: 420, mx: "auto", p: 3, mt: 4 }}>
            <form onSubmit={handleSubmit}>
                <Typography variant="h5" gutterBottom>
                    Банківський переказ
                </Typography>

                <OrderParamsForm {...orderParams}/>
                
                <AgreementCheckbox
                    checked={isAgreementAccepted}
                    onChange={(checked) => setIsAgreementAccepted(checked)}
                    onOpenOffer={() => handleOpen('offer')}
                    onOpenPrivacy={() => handleOpen('privacy')}
                />

                <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ fontWeight: "bold", px: 4 }}
                        disabled={!isAgreementAccepted}
                    >
                        {/* {t('OrderForm.PayButton')} */}
                        Рахунок-фактура
                    </Button>
                    <Button
                        type="button"
                        onClick={onClose}
                        variant="outlined"
                        color="secondary"
                    >
                        {t('OrderForm.ExitButton')}
                    </Button>
                </Stack>
            </form>
            
            <InfoModal
                open={isModalOpen}
                onCancel={handleCancel}
                onAccept={handleAccept}
                kind={kind}
            />
        </Paper>
    );
};

export default BanktransferForm;
